<div *ngIf="hasData" > 
    <pdf-viewer 
        [src]="pdfSrc"
        [render-text]="true"
        [original-size]="true"
        style="width: 1200px; height: 660px; " >
    </pdf-viewer>
</div>